import { render, staticRenderFns } from "./commentProductList.vue?vue&type=template&id=7481b0f6&scoped=true&lang=html&"
import script from "./commentProductList.vue?vue&type=script&lang=js&"
export * from "./commentProductList.vue?vue&type=script&lang=js&"
import style0 from "./commentProductList.vue?vue&type=style&index=0&id=7481b0f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7481b0f6",
  null
  
)

export default component.exports